import { render } from 'react-dom';
import 'jquery.js';
import { setupLayout } from 'common.js';
import { setupLoginControl } from 'inlineLogin.js';
import 'jquery-components/bootstrap-dropdown';
import ExcursionToolbarRoot from './components/ExcrusionToolbarRoot';
import { setupImagePreview } from 'jquery-common/image-previews';

function setupInlineLogin() {
    var $logonBkg = $(".logon-background");
    if ($logonBkg.length) {
        $(".js-localLogon").on('click', function (evt) { evt.preventDefault(); $logonBkg.show(); });
        $logonBkg.find(".close").on('click', function (evt) { evt.preventDefault(); $logonBkg.hide(); });
        setupLoginControl(function (_data) {
            window.location.reload();
        });
    }
}

function setupBackButon() {
    if (history.length < 2)
        return;

    $(".back-to-search").css({ opacity: 1, visibility: 'visible' });
}

export function setupExcursionDescription(params) {
    setupImagePreview();
    setupInlineLogin();
    setupBackButon();

    const target = document.getElementById('excursion-toolbar');
    if (target) {
        render(ExcursionToolbarRoot(params), target);
    }
}

export { setupLayout }